import React from 'react'

import { GENDER_OPTIONS } from 'constants/user'
import Label from 'components/AuthModal/components/Label'
import GenderSelect from 'components/AuthModal/components/GenderSelect'

const InputGender = ({ onChange, userData }) => {
  return (
    <div>
      <Label htmlFor="test">About me</Label>
      <div className="font-tomatoGrotesk-reg text-base">
        <GenderSelect
          name="gender"
          defaultLabel="My Gender"
          fullOptionsTitle="About me"
          options={GENDER_OPTIONS}
          userData={userData}
          onChange={onChange}
          value={userData.gender}
        />
      </div>
    </div>
  )
}

export default InputGender
